/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Team_BadgeInputs */

const en_mk_price_team_badge = /** @type {(inputs: Mk_Price_Team_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most popular`)
};

const id_mk_price_team_badge = /** @type {(inputs: Mk_Price_Team_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling banyak dipilih`)
};

/**
* | output |
* | --- |
* | "Most popular" |
*
* @param {Mk_Price_Team_BadgeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_team_badge = /** @type {((inputs?: Mk_Price_Team_BadgeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Team_BadgeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_team_badge(inputs)
	return en_mk_price_team_badge(inputs)
});